import {Country} from './country';
import {Perimeter} from './perimeter';

export class User {
	id: number;
	igg: string;
	first_name: string;
	last_name: string;
	email: string;
	lang_code: string;
	role: string;
	admin_country: Country;
	admin_countries: Country[];
	perimeters: Perimeter[];
	saved_search_filters: any;
	last_connection: Date;

	constructor(data = {}) {
		Object.assign(this, data);
	}

	isAdmin(): boolean {
		return this.role.toLowerCase() === 'admin';
	}

	isSuperAdmin(): boolean {
		return this.role.toLowerCase() === 'superadmin';
	}
}
